// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__20GZ3","form":"EditListingDescriptionPanel_form__2O-vu","title":"EditListingDescriptionPanel_title__2jXkm"};